import { createSlice } from '@reduxjs/toolkit'
import baseReducers from 'apiV2/store/base/reducers'
import baseInitialState from 'apiV2/store/base/initialState'

import { createInsuranceRequestAPI } from './asyncActions'

const insuranceQuoteSlice = createSlice({
  name: 'insurance_request',
  initialState: baseInitialState,
  reducers: baseReducers,
  extraReducers: {
    [createInsuranceRequestAPI.pending](state) {
      state.uiFlags.isCreating = true
    },
    [createInsuranceRequestAPI.fulfilled](state, action) {
      state.stagedRecord = action.payload
      state.uiFlags.isCreating = false
    },
    [createInsuranceRequestAPI.rejected](state) {
      state.uiFlags.isCreating = false
    },
  },
})

export default insuranceQuoteSlice
